<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td>
                  <a v-if="getRoleId != '33'" @click="openPage('/class_attendance/add')" class="btn-primary"><i class="fas fa-plus-square "></i> Add</a>
                </td>
                <td>
                  <a @click="exportClass()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Studio
              </div>
              <div class="col-sm-8">
                <b-form-select @change="changeStudioSelect" v-model="changeStudio">
                  <option :value="null">All Studio</option>
                  <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
          </div>
          <div class="col-md-4 text-right mt-4">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(thumbnail)="data">
            <b-btn @click="showModal('memberProfile' + data.item.id)" size="sm" class="btn-table green"><i class="fas fa-eye mr-5"></i>View</b-btn>
            <b-modal modal-class="modal-custom-image" hide-footer :ref="'memberProfile' + data.item.id" centered title="memberProfile">
              <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
            </b-modal>
          </template>
          <template v-slot:cell(name)="data">
            <template v-if="data.item.member">
              {{data.item.member.first_name}} {{data.item.member.last_name}}
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:cell(coaches)="data">
            <template v-if="data.item.classes_schedule.new_class_attendance.coach">
              {{data.item.classes_schedule.new_class_attendance.coach.name}}
            </template>
            <template v-else-if="data.item.classes_schedule.coach">
              {{data.item.classes_schedule.coach.name}}
            </template>
            <template v-else>-</template>
          </template>
          <!-- 'classes_schedule.new_class_attendance.class.name' -->
          <template v-slot:cell(className)="data">
            <template v-if="data.item.classes_schedule.new_class_attendance.class">
              {{data.item.classes_schedule.new_class_attendance.class.name}}
            </template>
            <template v-else-if="data.item.classes_schedule.class">
              {{data.item.classes_schedule.class.name}}
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:cell(cover)="data">
            <template v-if="data.item.cover_coaches">
              {{data.item.cover_coaches.name}} {{data.item.cover_coaches.name}}
            </template>
            <template v-else-if="data.item.classes_schedule.cover_coaches">
              {{data.item.classes_schedule.cover_coaches.name}}
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:cell(classTime)="data">
            <template v-if="data.item.classes_schedule">
              <div>{{data.item.classes_schedule.classes_day.name}}, {{parseDate(data.item.created_at)}}</div>
              {{parseTime(data.item.classes_schedule.classes_time.time_start)}} - {{parseTime(data.item.classes_schedule.classes_time.time_end)}}
            </template>
          </template>
          <template v-slot:cell(booking_status)="data">
            <template>
              <b-badge v-if="data.item.booking_status == 1" :variant="'success'" >Yes</b-badge>
              <b-badge v-if="data.item.booking_status == 0"  :variant="'warning'" >No</b-badge>
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'classAttendance',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'member.branch.name',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'member.email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'member.phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'className',
          label: 'Class Name',
          sortable: false
        },
        {
          key: 'coaches',
          label: 'Coaches',
          sortable: false
        },
        {
          key: 'cover',
          label: 'Cover',
          sortable: false
        },

        {
          key: 'classes_schedule.studio.name',
          label: 'Studio Name',
          sortable: false
        },
        {
          key: 'classTime',
          label: 'Class Time',
          sortable: false
        },
        {
          key: 'booking_status',
          label: 'Booking Status',
          sortable: false
        },
      ],
      items: [],
      dataBranch: [],
      optStudio: [],
      branch_id: null,
      changeStudio: null,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeDateBooking(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    parseDate (value) {
      return moment(value).format('DD-MM-YYYY')
    },
    parseTime (value) {
      return (value).slice(0, -3)
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/member/' + value
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editBlogCategory (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    changeBranch(event) {
      this.changeStudio = null
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc&branch_id=' + event).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeStudioSelect (event) {
      let cutDate = this.exportDates.split(' to ')
      let url = 'fitness/v1/history/class_attendance?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date=' + cutDate[0]
      + '&end_date=' + cutDate[1]

      if (event != null) {
        url += '&studio_id=' + event
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      let cutDate = this.exportDates.split(' to ')
      let url = 'fitness/v1/history/class_attendance_dashboard?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date=' + cutDate[0]
      + '&end_date=' + cutDate[1]
      + '&is_admin=1'

      if (this.changeStudio != null) {
        url += '&studio_id=' + this.changeStudio
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    exportClass() {
      let dates = this.exportDates.split(' to ')
      let url = 'fitness/v1/export/class_attendance?start_date='+dates[0]
        +'&end_date='+dates[1]
        +'&keyword=' + this.searchData

      if (this.changeStudio != null) {
        url += '&studio_id=' + this.changeStudio
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Class Attendance Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
